export default __webpack_public_path__ + "static/media/tapeTwo.f50a0ed0.svg";